import { createApiClient } from "@ram/api-client";
import { useRequestLoader } from "@ram/ui";

// In dev, Vite proxies `/api` to the Django server on :8000.
// In prod the SPA is served by Nginx at the same origin (§19.7), so the
// relative `/api` URL also works.
export const api = createApiClient({ baseURL: "" });

const { increment, decrement } = useRequestLoader();

// Requests marked `{ skipLoader: true }` (background pollers) don't touch the
// loader counter, so they never show the overlay. Everything else does.
api.interceptors.request.use((config) => {
  if (!config.skipLoader) increment();
  return config;
});

api.interceptors.response.use(
  (response) => { if (!response.config.skipLoader) decrement(); return response; },
  (error)    => { if (!error.config?.skipLoader) decrement(); return Promise.reject(error); },
);
